export class Primary {
  constructor() {
    this.name = 'Primary'
    this.content = {
      featured: false,
      featuredText: 'MOST POPULAR',
      hasTitle: true,
      title: 'ENTERPRISE',
      buttonLink: '',
      price: '$49',
      recurrency: 'monthly',
      headerBlocks: ['PricingTableTitleBlock', 'PricingTablePriceBlock', 'PricingTableDescriptionBlock'],
      contentBlocks: ['PricingTableListBlock'],
      footerBlocks: ['PricingTableButtonBlock'],
      listItems: [
        {title: 'Lorem ipsum dolor sit'},
        {title: 'Enim recusandae earum nemo labore'},
        {title: 'Adipisci deserunt aliquid aperiam delectus'},
        {title: 'Dolorum aliquid commodi'},
        {title: 'Vel iure dolorem maxime mollitia soluta'},
      ],
      hasDescription: true,
      buttonText: 'Get Started',
      description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
      hasList: true,
      class: 'fas',
      icon: 'fa-check',
    }
    this.view = this.viewHtml()
  }

  viewHtml() {
    return `<div>primary</div>`
  }

  featuredContainerClasses() {
    return [
      {property: 'TextAlignment', value: 'CENTER'},
      {property: 'Width', value: 'WIDTH_FULL'}
    ]
  }

  featuredClasses() {
    return [
      {property: 'Rounded', value: 'ROUNDED_LG'}
    ]
  }

  featuredStyles() {
    return [
      //
    ]
  }

  classes() {
    return [
      {property: 'Rounded', value: 'ROUNDED_LG'},
      {property: 'Shadow', value: 'SHADOW_MD'},
    ]
  }

  styles() {
    return [
    ]
  }

  titleContainerClasses() {
    return [
      {property: 'TextAlignment', value: 'LEFT'}
    ]
  }

  priceContainerClasses() {
    return [
      {property: 'TextAlignment', value: 'LEFT'}
    ]
  }

  priceClasses() {
    return [
      {property: 'FontSize', value: 'FONT_SIZE_5XL'},
      {property: 'FontWeight', value: 'BLACK'},
    ]
  }

  priceStyles() {
    return [
      {property:'TextColor', styleProperty: 'color', value: '#000000'},
    ]
  }

  descriptionContainerClasses() {
    return [
      {property: 'TextAlignment', value: 'LEFT'}
    ]
  }

  descriptionClasses() {
    return [
      {property: 'FontSize', value: 'FONT_SIZE_SM'},
      {property: 'FontWeight', value: 'NORMAL'},
    ]
  }

  descriptionStyles() {
    return [
      {property:'TextColor', styleProperty: 'color', value: '#9C9C9C'},
    ]
  }

  titleClasses() {
    return [
      {property: 'FontSize', value: 'FONT_SIZE_XS'},
      {property: 'FontWeight', value: 'BOLD'},
      {property: 'Rounded', value: 'ROUNDED_FULL'},
    ]
  }

  titleStyles() {
    return [
      {property:'TextColor', styleProperty: 'color', value: '#5244cc'},
      {property:'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg, #e4edff,#e4edff)'},
    ]
  }

  buttonClasses() {
    return [
      {property: 'Rounded', value: 'ROUNDED_MD'},
      {property: 'FontWeight', value: 'BOLD'},
      {property: 'Shadow', value: 'SHADOW_SM'},
    ]
  }

  buttonStyles() {
    return [
      {property:'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg, #5244cc,#5244cc)'},
      {property:'TextColor', styleProperty: 'color', value: '#ffffff'},
    ]
  }

  iconClasses() {
    return [
      {property: 'FontSize', value: 'FONT_SIZE_SM'},
    ]
  }

  iconStyles() {
    return [
      {property:'TextColor', styleProperty: 'color', value: '#5244cc'},
      {property: 'FontSize', value: 'FONT_SIZE_SM'},
    ]
  }

  listClasses() {
    return [
      {property: 'FontSize', value: 'FONT_SIZE_SM'},
      {property: 'FontWeight', value: 'NORMAL'},
    ]
  }

  listStyles() {
    return [
      {property:'TextColor', styleProperty: 'color', value: '#9C9C9C'},
    ]
  }

  headerClasses() {
    return [
      {property: 'PaddingTop', value: 'PADDING_TOP_XS'},
      {property: 'PaddingBottom', value: 'PADDING_BOTTOM_XS'},
      {property: 'PaddingLeft', value: 'PADDING_LEFT_XS'},
      {property: 'PaddingRight', value: 'PADDING_RIGHT_XS'},
    ]
  }

  headerStyles() {
    return [
      {property:'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg, #ffffff,#ffffff)'},
    ]
  }

  contentClasses() {
    return [
      {property: 'PaddingTop', value: 'PADDING_TOP_XS'},
      {property: 'PaddingBottom', value: 'PADDING_BOTTOM_XS'},
      {property: 'PaddingLeft', value: 'PADDING_LEFT_XS'},
      {property: 'PaddingRight', value: 'PADDING_RIGHT_XS'},
      {property: 'BorderStyle', value: 'BORDER_SOLID'},
      {property: 'BorderSideTopWidth', value: 'BORDER_TOP_THIN'},
      {property: 'BorderSideBottomWidth', value: 'BORDER_BOTTOM_0'},
      {property: 'BorderSideLeftWidth', value: 'BORDER_LEFT_0'},
      {property: 'BorderSideRightWidth', value: 'BORDER_RIGHT_0'},
    ]
  }

  contentStyles() {
    return [
      {property:'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg, #f8fafc,#f8fafc)'},
      {property:'BorderColor', styleProperty: 'border-color', value: '#ECEFEF'}
    ]
  }

  footerClasses() {
    return [
      {property: 'PaddingTop', value: 'PADDING_TOP_XS'},
      {property: 'PaddingBottom', value: 'PADDING_BOTTOM_XS'},
      {property: 'PaddingLeft', value: 'PADDING_LEFT_XS'},
      {property: 'PaddingRight', value: 'PADDING_RIGHT_XS'},
    ]
  }

  footerStyles() {
    return [
      {property:'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg, #f8fafc,#f8fafc)'},
    ]
  }

  buildData() {
    return {
      name: this.name,
      view: this.view,
    }
  }

  editorProperties() {
    return {
      content: this.content,
      headerClasses: {
        desktop: this.headerClasses(),
        tablet: this.headerClasses(),
        phone: this.headerClasses()
      },
      headerStyles: {
        desktop: this.headerStyles(),
        tablet: this.headerStyles(),
        phone: this.headerStyles()
      },
      titleContainerClasses: {
        desktop: this.titleContainerClasses(),
        tablet: this.titleContainerClasses(),
        phone: this.titleContainerClasses()
      },
      descriptionContainerClasses: {
        desktop: this.descriptionContainerClasses(),
        tablet: this.descriptionContainerClasses(),
        phone: this.descriptionContainerClasses()
      },
      descriptionClasses: {
        desktop: this.descriptionClasses(),
        tablet: this.descriptionClasses(),
        phone: this.descriptionClasses()
      },
      descriptionStyles: {
        desktop: this.descriptionStyles(),
        tablet: this.descriptionStyles(),
        phone: this.descriptionStyles()
      },
      titleClasses: {
        desktop: this.titleClasses(),
        tablet: this.titleClasses(),
        phone: this.titleClasses()
      },
      titleStyles: {
        desktop: this.titleStyles(),
        tablet: this.titleStyles(),
        phone: this.titleStyles()
      },
      buttonClasses: {
        desktop: this.buttonClasses(),
        tablet: this.buttonClasses(),
        phone: this.buttonClasses()
      },
      buttonStyles: {
        desktop: this.buttonStyles(),
        tablet: this.buttonStyles(),
        phone: this.buttonStyles()
      },
      contentClasses: {
        desktop: this.contentClasses(),
        tablet: this.contentClasses(),
        phone: this.contentClasses()
      },
      contentStyles: {
        desktop: this.contentStyles(),
        tablet: this.contentStyles(),
        phone: this.contentStyles()
      },
      iconClasses: {
        desktop: this.iconClasses(),
        tablet: this.iconClasses(),
        phone: this.iconClasses()
      },
      iconStyles: {
        desktop: this.iconStyles(),
        tablet: this.iconStyles(),
        phone: this.iconStyles()
      },
      listClasses: {
        desktop: this.listClasses(),
        tablet: this.listClasses(),
        phone: this.listClasses()
      },
      listStyles: {
        desktop: this.listStyles(),
        tablet: this.listStyles(),
        phone: this.listStyles()
      },
      priceContainerClasses: {
        desktop: this.priceContainerClasses(),
        tablet: this.priceContainerClasses(),
        phone: this.priceContainerClasses()
      },
      featuredContainerClasses: {
        desktop: this.featuredContainerClasses(),
        tablet: this.featuredContainerClasses(),
        phone: this.featuredContainerClasses()
      },
      featuredClasses: {
        desktop: this.featuredClasses(),
        tablet: this.featuredClasses(),
        phone: this.featuredClasses()
      },
      featuredStyles: {
        desktop: this.featuredStyles(),
        tablet: this.featuredStyles(),
        phone: this.featuredStyles()
      },
      priceClasses: {
        desktop: this.priceClasses(),
        tablet: this.priceClasses(),
        phone: this.priceClasses()
      },
      priceStyles: {
        desktop: this.priceStyles(),
        tablet: this.priceStyles(),
        phone: this.priceStyles()
      },
      footerClasses: {
        desktop: this.footerClasses(),
        tablet: this.footerClasses(),
        phone: this.footerClasses()
      },
      footerStyles: {
        desktop: this.footerStyles(),
        tablet: this.footerStyles(),
        phone: this.footerStyles()
      },
      styles: {
        phone: this.styles(),
        tablet: this.styles(),
        desktop: this.styles(),
      },
      classes: {
        phone: this.classes(),
        tablet: this.classes(),
        desktop: this.classes(),
      },
    }
  }
}